import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Carousel, CarouselItem, CarouselControl, CarouselIndicators } from "reactstrap";
import wralPlacement from "../../../assets/images/ad_preview/wral.png";
import AdDesignPreview from "../../partner-dashboard/components/ad-designs/ad-design-preview";
import "./preview-carousel.styles.scss";
import CreatomateAdPreview from "./creatomate-ad-preview";

const propTypes = {
  template: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    previewPath: PropTypes.string.isRequired,
    placements: PropTypes.arrayOf(PropTypes.string).isRequired,
    primaryMimeType: PropTypes.string.isRequired,
    isCreatomateTemplate: PropTypes.bool.isRequired,
    renderedJsonDocument: PropTypes.string.isRequired
  }).isRequired,
  uniqueKey: PropTypes.string.isRequired
};

const items = [
  {
    key: "wral",
    src: wralPlacement,
    altText: "WRAL News",
    // coefficient by which to scale the ad preview
    adScale: 0.56,
    topPosition: "24.1%",
    leftPosition: "11.4%"
  }
];

const VideoPreviewPlacement = ({ template, uniqueKey }) => {
  const ref = useRef(null);
  const containerWidth = 1000;
  const [activeIndex, setActiveIndex] = useState(0);
  const [animating, setAnimating] = useState(false);
  const VIDEO_SIZE_RATIO = 0.56;
  const BG_SIZE_RATIO = 0.6;

  const next = () => {
    if (animating) return;
    const nextIndex = activeIndex === items.length - 1 ? 0 : activeIndex + 1;
    setActiveIndex(nextIndex);
  };

  const previous = () => {
    if (animating) return;
    const nextIndex = activeIndex === 0 ? items.length - 1 : activeIndex - 1;
    setActiveIndex(nextIndex);
  };

  const goToIndex = newIndex => {
    if (animating) return;
    setActiveIndex(newIndex);
  };

  const slides = items.map(item => {
    return (
      <CarouselItem
        onExiting={() => setAnimating(true)}
        onExited={() => setAnimating(false)}
        key={item.key}
      >
        <div
          className="ad-design__carousel--sample-placement-bg"
          style={{
            backgroundImage: `url("${item.src}")`,
            width: containerWidth,
            height: containerWidth * BG_SIZE_RATIO
          }}
        >
          <div
            style={{
              position: "absolute",
              top: item.topPosition,
              left: item.leftPosition,
              width: containerWidth * item.adScale,
              height: containerWidth * item.adScale * VIDEO_SIZE_RATIO
            }}
          >
            {template.isCreatomateTemplate ? (
              <CreatomateAdPreview
                key={uniqueKey}
                creative={template}
                width={containerWidth * item.adScale}
                height={containerWidth * item.adScale * VIDEO_SIZE_RATIO}
              />
            ) : (
              <AdDesignPreview
                url={template.previewPath}
                mimeType={template.primaryMimeType}
                title={template.displayName}
                width={containerWidth * item.adScale}
                height={containerWidth * item.adScale * VIDEO_SIZE_RATIO}
                isCreatomateTemplate={template.isCreatomateTemplate}
                exactSize
              />
            )}
          </div>
        </div>
      </CarouselItem>
    );
  });

  return (
    <div ref={ref} className="py-0" data-testid="video-preview-placement">
      <Carousel
        className="ad-design__carousel"
        activeIndex={activeIndex}
        next={next}
        previous={previous}
      >
        <CarouselIndicators items={items} activeIndex={activeIndex} onClickHandler={goToIndex} />
        {slides}
        <CarouselControl direction="prev" directionText="Previous" onClickHandler={previous} />
        <CarouselControl direction="next" directionText="Next" onClickHandler={next} />
      </Carousel>
      <small>
        * The above sample placements are for example purposes only. Your specific ad may be
        displayed on other websites.
      </small>
    </div>
  );
};

VideoPreviewPlacement.propTypes = propTypes;

export default VideoPreviewPlacement;
